/**
 * Fetches optional site image overrides from the API.
 * Use getImage(key, defaultUrl) to resolve: returns override if set, else defaultUrl.
 * All hardcoded defaults remain; overrides are optional.
 */

import { useState, useEffect, useCallback } from 'react';

const API_URL = import.meta.env.VITE_API_URL || '';

export function useSiteImageOverrides() {
  const [overrides, setOverrides] = useState<Record<string, string>>({});

  useEffect(() => {
    let cancelled = false;
    fetch(`${API_URL}/api/site-image-overrides`)
      .then((res) => (res.ok ? res.json() : { overrides: {} }))
      .then((data) => {
        if (!cancelled && data.overrides) setOverrides(data.overrides);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  const getImage = useCallback(
    (key: string, defaultUrl: string): string => {
      const override = overrides[key];
      return override && override.trim() ? override : defaultUrl;
    },
    [overrides]
  );

  return { overrides, getImage };
}
